

























































































import { Component, Vue } from "vue-property-decorator";
import { ILoginModel } from "src/model";
import { UserService } from "src/services";
import Captcha from "src/components/common/captcha";
import privacyPolicy from "./sub/privacyPolicy.vue";
import userAgreement from "./sub/userAgreement.vue";

@Component({
  components: {
    Captcha,
    userAgreement,
    privacyPolicy,
  },
})
export default class LoginForm extends Vue {
  /**
   * 隐私声明
   * @protected
   * @returns UserService
   */
  protected actionPrivacy(): void {
    (this.$refs.privacyPolicy as any).show();
  }
  /**
   * 服务协议
   * @protected
   * @returns UserService
   */
  protected actionAgreement(): void {
    (this.$refs.userAgreement as any).show();
  }

  /**
   * 用户服务实例
   * @private
   * @return boolean
   */
  private _userService: UserService;

  /**
   * 用户登入模型
   * @private
   * @return IloginModel
   */
  private accountModel: ILoginModel = {
    account: "",
    password: "",
    trail: [],
  };

  /**
   * 获取或设置用户实例。
   * @protected
   * @returns UserService
   */
  protected get userService(): UserService {
    if (!this._userService) {
      this._userService = this.$serviceProvier.resolve<UserService>(UserService);
    }

    return this._userService;
  }

  /**
   * 登入表单。
   * @protected
   * @returns any
   */
  public get $form(): any {
    return this.$refs.form as any;
  }

  /**
   * 表单规则
   * @protected
   */
  protected get rules(): any {
    return {
      account: [{ required: true, message: "请输入用户名！", trigger: "blur" }],
      password: [{ required: true, message: "请输入密码！", trigger: "blur" }],
    };
  }

  /**
   * 是否显示验证码
   */
  protected isCaptcha: boolean = false;

  /**
   * 打开验证码
   */
  protected async verify(): Promise<void> {
    this.$form.validate(async (valid: boolean) => {
      if (valid) {
        this.isCaptcha = true;
      }
    });
  }

  /**
   * 登入
   * @private
   * @return void
   */
  protected async onHandleSubmit(trail: Array<number>): Promise<void> {
    this.$form.validate(async (valid: boolean) => {
      if (valid) {
        try {
          // 用户登入
          this.accountModel.trail = trail;
          let { content: result } = await this.userService.login(this.accountModel);
          // 存储token
          this.$store.dispatch("global/setToken", { accessToken: result.data.accessToken, refreshToken: result.data.refreshToken });
          this.$store.dispatch("global/setUserInfo", result.data);
          this.$nextTick(() => {
            this.$router.push("/shop");
          });
        } catch (err) {
          this.$message.error({
            duration: 3,
            content: JSON.stringify(err) || "服务器错误",
          });
          this.isCaptcha = false;
        }
      }
    });
  }

  /**
   * 切换注册面板
   * @private
   * @return void
   */
  private onRegister(): void {
    this.$router.push({ name: "register" });
  }
}
